import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useTranslation } from 'react-i18next';

const ENDPOINT_URL = '/profile/language';
const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type UpdateUserInput = paths[url]['post']['requestBody']['content']['application/json'];

export interface UpdateUserSuccessResponse {
    data: paths[url]['post']['responses']['200']['content']['application/json'];
}

export const useChangeLanguage = () => {
    const { t } = useTranslation();
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [validationErrors, setValidationErrors] = useState<any | null>(null);

    const request = async (props: UpdateUserInput) => {
        setLoading(true);
        setError(null);
        setValidationErrors(null);
        setSuccess(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ ...getCommonParameters(), ...props }),
            });

            const data = await response.json();

            if (!response.ok) {
                const errorMessage = data.message || t('common.error-occurred');
                const error = new Error(errorMessage) as ApiError;
                error.statusCode = response.status;
                error.errors = data.errors;

                throw error;
            }
            setSuccess(data.message);

        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
            err.errors && setValidationErrors(err.errors);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime, validationErrors, success };
};
